<template>
  <div class="flex flex-col h-full overflow-hidden w-full">
    <Title class="mb-4" :title="category" />
    <div
      v-if="subcategories[0] != category"
      class="grid grid-cols-3 gap-2 px-2 mb-4"
    >
      <p
        @click="selectedSubcategory = [subcategory]"
        v-for="subcategory in subcategories"
        :key="subcategory"
        class="border rounded-md"
        :class="{
          'bg-bnb-mustard text-white font-semibold':
            selectedSubcategory?.toString() == [subcategory]?.toString(),
        }"
      >
        {{ subcategory }}
      </p>
      <p
        @click="selectedSubcategory = subcategories"
        class="border rounded-md gap-2"
        :class="{
          'bg-bnb-mustard text-white font-semibold':
            selectedSubcategory == subcategories,
        }"
      >
        All
      </p>
    </div>
    <div class="flex-1 pb-4 overflow-auto">
      <div class="grid grid-cols-2 sm:grid-cols-4 p-2 gap-4">
        <MenuItem
          class="shadow-xl border border-white rounded-lg"
          v-for="item in $store.getters.menuByCategory(
            selectedSubcategory ?? subcategories
          )"
          :key="item"
          :menuItem="item"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Title from "@/components/Title.vue";
import MenuItem from "@/views/menu/MenuItem.vue";
export default {
  components: { Title, MenuItem },
  props: {
    category: String,
  },
  created() {
    if (this.category == "Drinks") {
      this.selectedSubcategory = this.subcategories = [
        "Beverages",
        "Cocktails",
        "Milkshakes",
        "Mocktails",
        "Smoothies",
      ];
    } else if (this.category == "Burgers, Sandwiches, Subs") {
      this.selectedSubcategory = this.subcategories = [
        "Burgers",
        "Sandwiches",
        "Subs",
      ];
    } else {
      this.selectedSubcategory = this.subcategories = [this.category];
    }
  },
  data() {
    return {
      subcategories: "",
      selectedSubcategory: this.subcategories,
    };
  },
};
</script>
